<app-logiciel-caisse-stock-toolbar
  #toolbar
  (filtersChange)="onFiltersChange($event)"
></app-logiciel-caisse-stock-toolbar>

<app-lc-table-shell [loading]="loading" [hasRows]="tableRows.length > 0">
<div class="table-full-width">
  <div class="table-responsive lc-table-scroll">
    <table class="table table-hover pos-ticket-table">
      <thead class="custom-header">
        <tr>
          <th>Référence</th>
          <th>Code barre</th>
          <th>Désignation</th>
          <th>Prix de vente</th>
          <th>Famille</th>
          <th>Stock physique</th>
          <th>Stock disponible</th>
          <th style="width: 80px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <app-lc-table-skeleton
          *ngIf="loading && tableRows.length === 0"
          [cols]="8"
        ></app-lc-table-skeleton>

        <ng-container *ngFor="let row of tableRows; let i = index">
          <tr
            class="lc-stock-parent-row"
            [class.row-has-children]="hasChildren(row)"
            [class.row-expanded]="isExpanded(i)"
            (click)="onParentRowClick($event, i, row)"
          >
            <td>
              <span class="ref-cell">
                <span
                  class="chevron"
                  [class.chevron-open]="isExpanded(i)"
                  [class.chevron-hidden]="!hasChildren(row)"
                  (click)="toggleExpand($event, i, row)"
                >
                  <i data-feather="chevron-right" [size]="16"></i>
                </span>
                <span>{{ cell(row, 'REFERENCE') }}</span>
              </span>
            </td>
            <td>{{ cell(row, 'CODE BARRE') }}</td>
            <td><span class="designation-cell">{{ cell(row, 'DESIGNATION') }}</span></td>
            <td>{{ cell(row, 'PRIX DE VENTE') }}</td>
            <td>{{ cell(row, 'FAMILLE') }}</td>
            <td>
              <span [ngClass]="stockQtyBadgeClasses(row['STOCK PHYSIQUE'])">
                {{ cell(row, 'STOCK PHYSIQUE') }}
              </span>
            </td>
            <td>
              <span [ngClass]="stockQtyBadgeClasses(row['STOCK DISPONIBLE'])">
                {{ cell(row, 'STOCK DISPONIBLE') }}
              </span>
            </td>
            <td>
              <button
                type="button"
                class="btn btn-sm btn-icon btn-outline-primary"
                title="Détail stock par entrepôt"
                (click)="openStockDetail(row); $event.stopPropagation()"
              >
                <i data-feather="eye" [size]="16"></i>
              </button>
            </td>
          </tr>

          <tr
            *ngFor="let child of childRows(row)"
            class="child-row lc-stock-child-row"
            [hidden]="!isExpanded(i)"
            (dblclick)="onChildRowDblClick($event, child)"
          >
            <td>{{ cell(child, 'REFERENCE') }}</td>
            <td>{{ cell(child, 'CODE BARRE') }}</td>
            <td><span class="designation-cell">{{ cell(child, 'DESIGNATION') }}</span></td>
            <td>{{ cell(child, 'PRIX DE VENTE') }}</td>
            <td>{{ cell(child, 'FAMILLE') }}</td>
            <td>
              <span [ngClass]="stockQtyBadgeClasses(child['STOCK PHYSIQUE'])">
                {{ cell(child, 'STOCK PHYSIQUE') }}
              </span>
            </td>
            <td>
              <span [ngClass]="stockQtyBadgeClasses(child['STOCK DISPONIBLE'])">
                {{ cell(child, 'STOCK DISPONIBLE') }}
              </span>
            </td>
            <td>
              <button
                type="button"
                class="btn btn-sm btn-icon btn-outline-primary"
                title="Détail stock par entrepôt"
                (click)="openStockDetail(child); $event.stopPropagation()"
              >
                <i data-feather="eye" [size]="16"></i>
              </button>
            </td>
          </tr>
        </ng-container>

        <tr *ngIf="!loading && tableRows.length === 0" class="lc-empty-row">
          <td colspan="8">Pas de données à afficher</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</app-lc-table-shell>

<app-logiciel-caisse-pos-pagination
  [currentPage]="currentPage"
  [totalPages]="totalPages"
  [totalItems]="serverTotal"
  [pageSize]="pageSize"
  (pageChange)="onPageChange($event)"
  (pageSizeChange)="onPageSizeChange($event)"
></app-logiciel-caisse-pos-pagination>

<div class="lc-stock-pagination-spacer"></div>

<div
  class="stock-detail-overlay"
  *ngIf="stockDetailOpen"
  (click)="closeStockDetail()"
>
  <div
    class="stock-detail-dialog"
    (click)="$event.stopPropagation()"
    role="dialog"
    aria-modal="true"
    aria-labelledby="stock-detail-title"
  >
    <div class="stock-detail-header">
      <div class="stock-detail-header__text">
        <h2 id="stock-detail-title" class="stock-detail-title">Stock par entrepôt</h2>
        <p class="stock-detail-subtitle" [title]="stockDetailTitle">{{ stockDetailTitle }}</p>
      </div>
      <button type="button" class="stock-detail-close" (click)="closeStockDetail()" aria-label="Fermer">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="stock-detail-body">
      <div *ngIf="stockDetailLoading" class="stock-detail-state stock-detail-state--loading">
        <span class="stock-detail-spinner" aria-hidden="true"></span>
        <p>Chargement du stock…</p>
      </div>

      <ng-container *ngIf="!stockDetailLoading">
        <div *ngIf="stockDetailLines.length === 0" class="stock-detail-state stock-detail-state--empty">
          <p class="stock-detail-state__title">Aucun stock trouvé</p>
          <p class="stock-detail-state__hint">
            Aucune ligne pour ce produit dans le périmètre (établissement / entrepôt) sélectionné.
          </p>
        </div>

        <div *ngIf="stockDetailLines.length > 0" class="stock-detail-table-wrap">
          <table class="stock-detail-table">
            <thead>
              <tr>
                <th>Entrepôt</th>
                <th class="num">Physique</th>
                <th class="num">Disponible</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let line of stockDetailLines">
                <td>
                  <span class="stock-detail-warehouse">{{ line.entrepot_libelle }}</span>
                </td>
                <td class="num">
                  <span class="stock-detail-qty">{{ formatStockQty(line.stock_physique) }}</span>
                </td>
                <td class="num">
                  <span
                    class="stock-detail-qty stock-detail-qty--available"
                    [class.stock-detail-qty--zero]="line.stock_disponible <= 0"
                  >
                    {{ formatStockQty(line.stock_disponible) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </div>

    <div class="stock-detail-footer" *ngIf="!stockDetailLoading && stockDetailLines.length > 0">
      <div class="stock-detail-total">
        <span class="stock-detail-total__label">Total physique</span>
        <strong>{{ formatStockQty(stockDetailTotalPhysique) }}</strong>
      </div>
      <div class="stock-detail-total">
        <span class="stock-detail-total__label">Total disponible</span>
        <strong class="stock-detail-total__available">{{ formatStockQty(stockDetailTotalDisponible) }}</strong>
      </div>
    </div>
  </div>
</div>
